import { LearnMoreLink } from './identity-cards/learn-more-link.model';

export const templateLinks: LearnMoreLink[] = [
  {
    titleCode: 'ongoingSubmissions',
    url: 'https://portal.productboard.com/wm6whau7st9md1ulztigrv4n/c/160-sitemate-forms-part-2-recurring-submissions?utm_medium=social&utm_source=portal_share',
  },
  {
    titleCode: 'singleSubmissions',
    url: 'https://portal.productboard.com/wm6whau7st9md1ulztigrv4n/c/48-sitemate-forms-part-1-single-submissions?utm_medium=social&utm_source=portal_share',
  },
];
